module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalBase', {
    attrs: {
      "withContent": true,
      "maxWidth": 'default'
    },
    on: {
      "close": _vm.cancel
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('section', [_c('label', [_vm._v(_vm._s(_vm.$t("plano.saveAsModal.saveAsLabel")) + " :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlano.name),
      expression: "newPlano.name"
    }],
    staticClass: "nameInput",
    class: {
      empty: _vm.error.name
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlano.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlano.name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.error.name) ? _c('label', {
    staticClass: "errorMessage"
  }, [_vm._v(_vm._s(_vm.$t("common.required")))]) : _vm._e()]), _vm._v(" "), _c('section', [_c('h1', [_vm._v(_vm._s(_vm.$t("common.campaign")))]), _vm._v(" "), _c('div', _vm._l((_vm.listCampaigns), function(campaign) {
    return _c('p', {
      key: campaign.id,
      staticClass: "brandLogo txtCenter uppercase",
      class: {
        elementSelected: campaign.id === _vm.newPlano.campaign.id
      },
      on: {
        "click": function($event) {
          _vm.selectCampaign(campaign);
        }
      }
    }, [_vm._v("\n                " + _vm._s(campaign.name) + "\n            ")])
  }))]), _vm._v(" "), _c('footer', {
    staticClass: "txtCenter"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.saveNewPlano
    }
  }, [_vm._v(_vm._s(_vm.$t("common.save")))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t("common.cancel")))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ce8b4b4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/modal/ModalSaveAsPlano.vue
// module id = 3251
// module chunks = 0